module.exports = __webpack_public_path__ + "static/img/msg-min2.91c4583.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/box/msg-min2.png
// module id = Mmh0
// module chunks = 1